import { useState, useEffect } from "react";
export default function Articles(props){
    const urlRss = "https://api.rss2json.com/v1/api.json?rss_url=https://medium.com/feed/@ahmedyusuf";
    const [articles, setArticles] = useState(null);

    
   useEffect(function(){

    //ambil Artikel dari medium
    async function getArticles() {
        const httpResp = await fetch(urlRss);
        const responseJson = await httpResp.json();
        if(responseJson.status === 'ok'){
            setArticles (<>
                
                    {responseJson.items.map(function(item){
                        const thumbnail = item.description.toString().match(/<img[^>]+src="([^">]+)"/)[1];
                        return ArticleComponent(item.title, thumbnail, item.link, getTextBetweenStrings(item.description, "<p>", "</p>"))
                    })}
            </>);
        }else{
            setArticles (<><p>Error loading articles</p></>)
        }
    }
    
    getArticles();
   },[]);

    //map per artikel jadi satu komponen
    function ArticleComponent(title, image, link, description){
        return (<>
            <a href={link} target="_blank" rel="noopener noreferrer"> 
                <div className="bg-white shadow-sm hover:scale-95 transition-all duration-500 w-full h-40 lg:h-52 border border-slate-200 border-solid rounded-xl overflow-clip">
                    <img
                        className="object-cover object-top w-full h-1/2 lg:h-4/6"
                        src={image}
                        alt={title}
                    />
                    <div className="m-2">
                        <div className="text-[10px] md:text-sm text-slate-600 font-semibold">{title}</div>
                    </div>
                </div>
            </a>
        </>)
    }

    function getTextBetweenStrings(str, startString, endString) {
        // mencari index dari startString
        const startIndex = str.indexOf(startString);
            // jika startString tidak ditemukan, kembalikan string kosong
        if (startIndex === -1) {
            return '';
        }
        
        // tambahkan panjang startString ke startIndex untuk menemukan awal dari teks yang ingin diambil
        const start = startIndex + startString.length;
        // ambil sisa string setelah startString
        let end = str.substring(start);
        // mencari index dari endString dalam sisa string
        const endIndex = end.indexOf(endString);
        
        // jika endString tidak ditemukan, kembalikan string kosong
        if (endIndex === -1) {
            return '';
        }
        
        // ambil teks di antara start dan endIndex dalam sisa string
        const text = end.substring(0, endIndex);
        
        return text;
        }

        return (<>
            <section ref={props.refs} className="bg-[rgba(247,250,251,1)] py-10 sm:py-20" id="article" aria-label="Medium articles">
                <div className="w-full flex">
                <h2 className="text-4xl sm:text-6xl lg:text-6xl sm:my-10 md:my-50 mx-auto font-semibold bg-gradient-to-r from-blue-900 to-teal-600 bg-clip-text text-transparent text-center inline-block">My Medium Articles</h2></div>
                <div className="grid mx-10 grid-cols-2 md:grid-cols-3 lg:grid-cols-4 mt-10 gap-5">
                {articles == null ? <p>Loading</p> : articles}
                </div>
            </section>
        </>)

}